if (!customElements.get("s-main-cart")) {
  customElements.define(
    "s-main-cart",
    class SectionCartModal extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;

        this.headerItemCount = document.querySelector(".js-header__cart-count");
        
        this.addEventsListeners();

        window.PubSub.subscribe('cart:update', this.updateCart);
      }

      disconnectedCallback() {
      }

      updateCart = () => {
        this.classList.add("is-loading");
        
        fetch(window.Shopify.routes.root + '?section_id=' + this.sectionId)
        .then(response => response.text())
        .then(html => {
          let newSection = document.createElement('div');
          newSection.innerHTML = html;
          let newCartModal = newSection.querySelector('.s-main-cart');
          this.dataset.collectionHandle = newCartModal.dataset.collectionHandle;
          
          this.innerHTML = newCartModal.innerHTML;
          this.headerItemCount.innerHTML = this.querySelector(".js-main-cart__count").innerHTML;
          this.classList.remove("is-loading");

          this.addEventsListeners();
        })
        .catch(error => console.error(error));
      }

      addEventsListeners = () => {
        this.note = this.querySelector(".js-main-cart__note");

        this.note.addEventListener("change", this.noteUpdater);
      }

      noteUpdater = () => {

        fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ note: this.note.value }),
        })
        .then(response => response.json())
        .then(data => {
            console.log("Note updated:", data);
        })
        .catch(error => console.error("Error updating note:", error));
      }
    }
  );
}
